import { getCurrentLangName, getFanPageUrl, getFlagByCountryCode, getStudentNickname } from "helpers/String.helper";
import React from "react";
import LoadingComponent from "commons/loading/Loading.component";
import { getImageUrl } from "helpers/Image.helper";
import { getLanguageValue } from "locales/i18n";
import { PAGE_TYPE } from "enums";
import { useNavigate } from "react-router-dom";

interface StudentInfoPopupProps {
    onClose: () => void;
    info: any;
    isLoading: boolean;
    errorMessage: string;
    onLike: (congratulationItemId: number) => Promise<void>;
    isOnNetworking: boolean;
}

const CongratulationInfoPopupComponent: React.FC<StudentInfoPopupProps> = ({ onClose, info, isLoading, errorMessage, onLike, isOnNetworking }) => {
    const navigate = useNavigate();
    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 w-screen h-screen top-0 left-0 p-4 !m-0">
            <div className="bg-white rounded-2xl p-6 w-full max-w-2xl mx-auto">
                <div className="flex items-center justify-between mb-4">
                    <h3 className="text-lg font-bold text-gray-900">
                        {getLanguageValue(PAGE_TYPE.STUDENT, "congratulationInfoPopup.txtTitle")}
                    </h3>
                    <button className="text-gray-400 hover:text-gray-600" onClick={onClose}>
                        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
                        </svg>
                    </button>
                </div>

                {isLoading ? (
                    <LoadingComponent />
                ) : errorMessage ? (
                    <div className="flex flex-col items-center justify-center py-10 text-gray-500">
                        <p className="text-center">{errorMessage}</p>
                    </div>
                ) : (
                    <div className="flex flex-col items-center">
                        <div className="w-32 h-32 rounded-full bg-gray-200 overflow-hidden mb-4">
                            <img
                                src={getImageUrl(info?.userStudentInfo?.profileImageInfo)}
                                alt={info?.userStudentInfo?.nickname}
                                className="w-full h-full object-cover"
                            />
                        </div>

                        <h2 className="mb-2 text-center">
                            <span className="text-xl font-bold">
                                {getStudentNickname(info?.userStudentInfo)}
                            </span>
                            <br />
                            <span className="text-sm text-gray-600"> {info?.userStudentInfo?.birthYear ? `(${info?.userStudentInfo?.birthYear})` : ""}</span>
                        </h2>

                        <p className="text-gray-600 mb-4 text-center">
                            {getFlagByCountryCode(info?.userStudentInfo?.countryInfo?.code)}
                            {getCurrentLangName(info?.userStudentInfo?.countryInfo?.names)}
                        </p>

                        {(
                            info?.congratulationItemList?.length > 0) &&
                            info?.congratulationItemList?.map((item: any) => (
                                <div key={item.id} className="flex items-center justify-between w-full max-w-md mb-3 p-3 bg-gray-50 rounded-lg">
                                    <div className="flex-1">
                                        <span className="text-gray-900 font-medium">
                                            {getCurrentLangName(item.congratulationItemTypeInfo.names)}
                                        </span>
                                    </div>

                                    <div className="flex items-center">
                                        <span className="mr-1">{item.likeCount}</span>

                                        <button
                                            onClick={() => onLike(item.id)}
                                            disabled={isOnNetworking}
                                            className={`ml-4 p-2 rounded-full transition-colors ${item.isLiked
                                                ? 'bg-red-100 text-red-500 hover:bg-red-200'
                                                : 'bg-gray-100 text-gray-400 hover:bg-gray-200'
                                                }`}
                                        >

                                            <svg
                                                className="w-5 h-5"
                                                fill={item.isLiked ? "currentColor" : "none"}
                                                stroke="currentColor"
                                                viewBox="0 0 24 24"
                                            >
                                                <path
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                    strokeWidth="2"
                                                    d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z"
                                                />
                                            </svg>
                                        </button>
                                    </div>
                                </div>
                            ))
                        }
                    </div>
                )}
            </div>
        </div>
    );
};

export default CongratulationInfoPopupComponent;